import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
// Formatação pt-BR das métricas da VSL Dinâmica. O BE manda taxas como fração 0–1.

const numberFormat = new Intl.NumberFormat(getInterfaceLanguage());

export function formatNumber(value: number | null | undefined): string {
  return numberFormat.format(Number.isFinite(value as number) ? (value as number) : 0);
}

// Divisão que nunca devolve NaN/Infinity (0 visualizações → 0).
export function safeRate(numerator: number, denominator: number): number {
  if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || denominator <= 0) return 0;
  return numerator / denominator;
}

// Segundos em m:ss (eixo e médias da retenção).
export function formatSeconds(seconds: number | null | undefined): string {
  const total = Number.isFinite(seconds as number) ? Math.max(0, Math.round(seconds as number)) : 0;
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

export function formatPercent(fraction: number | null | undefined): string {
  const value = Number.isFinite(fraction as number) ? (fraction as number) : 0;
  return `${(value * 100).toLocaleString(getInterfaceLanguage(), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`;
}
